import { Pipe, PipeTransform } from '@angular/core';
import { CurrencyPipe } from '@angular/common';

@Pipe({
  name: 'epgCurrency'
})
export class EpgCurrencyPipe implements PipeTransform {
  constructor(private currencyPipe: CurrencyPipe) {}

  transform(value: number | string | null | undefined, digitsInfo?: string): string | null {
    // Always use USD format with 'en-US' locale to ensure consistent formatting (1,500.00 $)
    return this.currencyPipe.transform(value, 'USD', 'symbol-narrow', digitsInfo || '1.2-2', 'en-US');
  }
}
